import { StateProps } from './transactionsListModels';

export const mapStateToProps = (state: any): StateProps => {
    const allEnums = state.enums.get('allEnums');

    return {
        customFields: allEnums.get('CUSTOM_ENTITY_TIMESHEET'),
    };
};
